import { render, staticRenderFns } from "./MessageSendWithAttachment.vue?vue&type=template&id=656bd1ca&"
import script from "./MessageSendWithAttachment.vue?vue&type=script&lang=ts&"
export * from "./MessageSendWithAttachment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports